import { styled } from '@mui/material/styles';

const IconWrap = styled('span')({
  display: 'inline-flex',
});

export function SettingsIcon() {
  return (
    <IconWrap>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 9.25C10.4812 9.25 9.25 10.4812 9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C13.5188 14.75 14.75 13.5188 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25Z"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M19.2 13.05V10.95L17.3576 10.3906C17.1753 9.81207 16.8704 9.27895 16.4656 8.83056L16.9278 6.96867L15.0313 5.07217L13.1694 5.53438C12.7211 5.12957 12.1879 4.82469 11.6094 4.64244L11.05 2.8H8.95L8.39056 4.64244C7.81207 4.82469 7.27895 5.12957 6.83056 5.53438L4.96867 5.07217L3.07217 6.96867L3.53438 8.83056C3.12957 9.27895 2.82469 9.81207 2.64244 10.3906L0.8 10.95V13.05L2.64244 13.6094C2.82469 14.1879 3.12957 14.7211 3.53438 15.1694L3.07217 17.0313L4.96867 18.9278L6.83056 18.4656C7.27895 18.8704 7.81207 19.1753 8.39056 19.3576L8.95 21.2H11.05L11.6094 19.3576C12.1879 19.1753 12.7211 18.8704 13.1694 18.4656L15.0313 18.9278L16.9278 17.0313L16.4656 15.1694C16.8704 14.7211 17.1753 14.1879 17.3576 13.6094L19.2 13.05Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrap>
  );
}
